export default __webpack_public_path__ + "static/eGdFSJfA-19150d225f6623fc86aaba69a57abc60.svg";